<div class="edit-trip-dialog" [formGroup]="lrForm">

  <!-- Close Button -->
  <div class="trip-detail-popup-right">
    <img src="../../../assets/img/icons8-macos-close-60.png" class="close-icons" (click)="close()" />
  </div>

  <!-- Header -->
  <div class="dialog-header">
    <h4>Update LR</h4>
    <div class="header-line"></div>

    <!-- Highlighted Header Section -->
    <div class="lr-header-box">
      <!-- Trip / LR Summary -->
      <div class="row">
        <div class="col-sm-3">
          <div class="head">Trip ID : {{ data.items.trip_id }}</div>
        </div>

        <div class="col-sm-3">
          <div class="head">LR No : {{ selectedLR.elr_no }}</div>
        </div>

        <div class="col-sm-3">
          <div class="head">Vehicle No : {{ data.items.truck_info[0]?.truck_number }}</div>
        </div>

        <div class="col-sm-3">
          <div class="head">Pickup Date : {{ data.items.pickup_date | date:'dd-MM-yyyy' }}</div>
        </div>
      </div>

      <!-- Update Method -->
      <div class="row justify-content-center mb-3">
        <div class="col-auto">
          <label class="radio-label">
            <input type="radio" value="eway" formControlName="update_method" />
            Update LR by E-Way Bill
          </label>
        </div>

        <div class="col-auto">
          <label class="radio-label">
            <input type="radio" value="manual" formControlName="update_method" />
            Update LR by Manual Entry
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="dialog-body">
    <!-- ================= E-WAY BILL ================= -->
    <ng-container *ngIf="lrForm.get('update_method')?.value === 'eway'">
      <div class="section-title">E-Way Bill Details</div>
      <div class="">
        <div class="col-sm-6 mb-2">
          <div class="head">E-Way Bill Number</div>
          <input class="input-grey" placeholder="Enter E-Way Bill Number" formControlName="eway_bill_no" />
        </div>

        <div class="col-sm-6 mb-2">
          <div class="head">E-Way Bill Date</div>
          <input type="date" class="input-grey" formControlName="eway_bill_date" />
        </div>
      </div>
    </ng-container>

    <!-- ================= MANUAL ENTRY ================= -->
    <ng-container *ngIf="lrForm.get('update_method')?.value === 'manual'">
      <!-- CONSIGNOR -->
      <div class="section-title">Consignor Details</div>
      <div class="row">
        <div class="col-sm-3">
          <div class="head">Consignor Name <span class="text-danger">*</span></div>
          <input class="input-grey" formControlName="consignor_name" placeholder="Enter Consignor Name" />
          <div *ngIf="lrForm.get('consignor_name')?.touched && lrForm.get('consignor_name')?.invalid"
            class="text-danger small">
            Consignor Name is required
          </div>
        </div>

        <div class="col-sm-3">
          <div class="head">Consignor Address <span class="text-danger">*</span></div>
          <input class="input-grey" formControlName="consignor_address" placeholder="Enter Consignor Address" />
          <div *ngIf="lrForm.get('consignor_address')?.touched && lrForm.get('consignor_address')?.invalid"
            class="text-danger small">
            Address is required
          </div>
        </div>

        <div class="col-sm-3">
          <div class="head">Consignor City <span class="text-danger">*</span></div>
          <input class="input-grey" formControlName="consignor_city" placeholder="Enter Consignor City" />
          <div *ngIf="lrForm.get('consignor_city')?.touched && lrForm.get('consignor_city')?.invalid"
            class="text-danger small">
            City is required
          </div>
        </div>

        <div class="col-sm-3">
          <div class="head">Consignor Pincode <span class="text-danger">*</span></div>
          <input class="input-grey" formControlName="consignor_pincode" placeholder="Enter Pincode" maxlength="6"
            (keypress)="onlyNumbers($event)" />
          <div *ngIf="lrForm.get('consignor_pincode')?.touched && lrForm.get('consignor_pincode')?.invalid"
            class="text-danger small">
            <div *ngIf="lrForm.get('consignor_pincode')?.errors?.['required']">Pincode is required</div>
            <div *ngIf="lrForm.get('consignor_pincode')?.errors?.['pattern']">Enter valid 6-digit Pincode</div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-3">
          <div class="head">Consignor GST No <span class="text-danger">*</span></div>
          <input class="input-grey" formControlName="consignor_gst_no" placeholder="Enter Consignor GST No" />
          <div *ngIf="lrForm.get('consignor_gst_no')?.touched && lrForm.get('consignor_gst_no')?.invalid"
            class="text-danger small">
            <div *ngIf="lrForm.get('consignor_gst_no')?.errors?.['required']">GST No is required</div>
            <div *ngIf="lrForm.get('consignor_gst_no')?.errors?.['pattern']">Enter valid GST No</div>
          </div>
        </div>
      </div>

      <!-- CONSIGNEE -->
      <div class="section-title">Consignee Details</div>
      <div class="row">
        <div class="col-sm-3">
          <div class="head">Consignee Name <span class="text-danger">*</span></div>
          <input class="input-grey" formControlName="consignee_name" placeholder="Enter Consignee Name" />
          <div *ngIf="lrForm.get('consignee_name')?.touched && lrForm.get('consignee_name')?.invalid"
            class="text-danger small">
            Consignee Name is required
          </div>
        </div>

        <div class="col-sm-3">
          <div class="head">Consignee Address <span class="text-danger">*</span></div>
          <input class="input-grey" formControlName="consignee_address" placeholder="Enter Consignee Address" />
          <div *ngIf="lrForm.get('consignee_address')?.touched && lrForm.get('consignee_address')?.invalid"
            class="text-danger small">
            Address is required
          </div>
        </div>

        <div class="col-sm-3">
          <div class="head">Consignee City <span class="text-danger">*</span></div>
          <input class="input-grey" formControlName="consignee_city" placeholder="Enter Consignee City" />
          <div *ngIf="lrForm.get('consignee_city')?.touched && lrForm.get('consignee_city')?.invalid"
            class="text-danger small">
            City is required
          </div>
        </div>

        <div class="col-sm-3">
          <div class="head">Consignee Pincode <span class="text-danger">*</span></div>
          <input class="input-grey" formControlName="consignee_pincode" placeholder="Enter Pincode" maxlength="6"
            (keypress)="onlyNumbers($event)" />
          <div *ngIf="lrForm.get('consignee_pincode')?.touched && lrForm.get('consignee_pincode')?.invalid"
            class="text-danger small">
            <div *ngIf="lrForm.get('consignee_pincode')?.errors?.['required']">Pincode is required</div>
            <div *ngIf="lrForm.get('consignee_pincode')?.errors?.['pattern']">Enter valid 6-digit Pincode</div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-3">
          <div class="head">Consignee GST No <span class="text-danger">*</span></div>
          <input class="input-grey" formControlName="consignee_gst_no" placeholder="Enter Consignee GST No" />
          <div *ngIf="lrForm.get('consignee_gst_no')?.touched && lrForm.get('consignee_gst_no')?.invalid"
            class="text-danger small">
            <div *ngIf="lrForm.get('consignee_gst_no')?.errors?.['required']">GST No is required</div>
            <div *ngIf="lrForm.get('consignee_gst_no')?.errors?.['pattern']">Enter valid GST No</div>
          </div>
        </div>
      </div>

      <!-- INVOICE & E-WAY BILL -->
      <div class="section-title">Invoice & E-Way Bill Details</div>
      <div class="row">
        <div class="col-sm-3">
          <div class="head">Invoice Date <span class="text-danger">*</span></div>
          <input type="date" class="input-grey" formControlName="invoice_date" [max]="today" />
          <div *ngIf="lrForm.get('invoice_date')?.touched && lrForm.get('invoice_date')?.invalid"
            class="text-danger small">
            Invoice Date is required
          </div>
        </div>

        <div class="col-sm-3">
          <div class="head">Invoice No <span class="text-danger">*</span></div>
          <input class="input-grey" formControlName="invoice_no" placeholder="Enter Invoice No" />
          <div *ngIf="lrForm.get('invoice_no')?.touched && lrForm.get('invoice_no')?.invalid" class="text-danger small">
            Invoice No is required
          </div>
        </div>

        <div class="col-sm-3">
          <div class="head">Material Name <span class="text-danger">*</span></div>
          <input class="input-grey" formControlName="material_name" placeholder="Enter Material Name" />
          <div *ngIf="lrForm.get('material_name')?.touched && lrForm.get('material_name')?.invalid"
            class="text-danger small">
            Material Name is required
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-3">
          <div class="head">E-Way Bill Number <span class="text-danger">*</span></div>
          <input class="input-grey" formControlName="eway_bill_no" placeholder="Enter E-Way Bill Number" />
          <div *ngIf="lrForm.get('eway_bill_no')?.touched && lrForm.get('eway_bill_no')?.invalid"
            class="text-danger small">
            E-Way Bill Number is required
          </div>
        </div>

        <div class="col-sm-3">
          <div class="head">E-Way Bill Date <span class="text-danger">*</span></div>
          <input type="date" class="input-grey" formControlName="eway_bill_date" [max]="today" />
          <div *ngIf="lrForm.get('eway_bill_date')?.touched && lrForm.get('eway_bill_date')?.invalid"
            class="text-danger small">
            E-Way Bill Date is required
          </div>
        </div>
      </div>

    </ng-container>
  </div>

  <!-- Footer -->
  <div class="dialog-footer">
    <button class="submit-btn mb-4" (click)="updateLR()">
      Submit
    </button>
  </div>

</div>